import React from 'react';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../../images/mcmasterLogoWhiteMar.png';
import './LoginCard.css';

// User authentication hook that connected to the backend user auth API
import { useAuth } from '../../hooks/useAuth.js'

const LoginCard = () => {
    // Initialize connection to login authorization and login credentials
    const { login } = useAuth()
    
    const navigate = useNavigate()
    const [creds, setCreds] = useState({uname: '', upass: ''})
    const [error, setError] = useState('')

    const handleLogin = async(e) => {
        e.preventDefault()
        const loginSuccess = await login(creds);
        console.log("Response Status:", loginSuccess.status);
        if (loginSuccess.ok) {
            // login worked; set uname and upass and go to the chatbot page
            const data = await loginSuccess.json();
            localStorage.setItem("uid",data.uid);
            localStorage.setItem("uname",creds.uname);
            navigate('/')
        } else {
            setError('Login failed: Invalid username or password')
        }
    }

    return (
        <div className='login-card'>
            <div className='logo-container'>
                <img className='logo-login' src={Logo}/>
            </div>
            <div >
                <form className='field-container' onSubmit={handleLogin}>
                    {error && <p className='error-message'>{error}</p>}
                    <input 
                        className='input-field' 
                        placeholder='Username' 
                        type='text' 
                        value={creds.uname} 
                        onChange={(e) => setCreds({...creds, uname: e.target.value})}
                    />
                    <input 
                        className='input-field' 
                        placeholder='Password' 
                        type='password'
                        value={creds.upass}
                        onChange={(e) => setCreds({...creds, upass: e.target.value})}
                    />
                    <button className='login-button' type='submit'>Login ➜</button>
                </form>
            </div>
        </div>
    );
};

export default LoginCard;